var OVERLAY_PRESENTATIONS = [
  "modal",
  "transparentModal",
  "fullScreenModal",
  "formSheet",
  "pageSheet",
  "containedModal",
  "containedTransparentModal"
];
function isOverlayPresentation(options) {
  var presentation = options === null || options === void 0 ? void 0 : options.presentation;
  if (!presentation) return false;
  return OVERLAY_PRESENTATIONS.includes(presentation);
}
function isTransparentOverlay(options) {
  var presentation = options === null || options === void 0 ? void 0 : options.presentation;
  return presentation === "transparentModal" || presentation === "containedTransparentModal";
}
function convertStackStateToNonOverlayState(state, descriptors) {
  var isOverlay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : isOverlayPresentation;
  var lastNonOverlay = findLastNonOverlayIndex(state, descriptors, isOverlay);
  var routes = state.routes.slice(0, lastNonOverlay + 1);
  var index = state.index;
  if (index >= routes.length) {
    index = routes.length > 0 ? routes.length - 1 : 0;
  }
  return {
    routes,
    index
  };
}
function findLastNonOverlayIndex(state, descriptors) {
  var isOverlay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : isOverlayPresentation;
  for (var i = state.index; i >= 0; i--) {
    var _descriptors_state_routes_i_key;
    if (!isOverlay((_descriptors_state_routes_i_key = descriptors[state.routes[i].key]) === null || _descriptors_state_routes_i_key === void 0 ? void 0 : _descriptors_state_routes_i_key.options)) {
      return i;
    }
  }
  return -1;
}
export {
  convertStackStateToNonOverlayState,
  findLastNonOverlayIndex,
  isOverlayPresentation,
  isTransparentOverlay
};
//# sourceMappingURL=stackStateUtils.js.map
